// extracted by mini-css-extract-plugin
export default {"tabs":"JUM2H","hasContent":"Xlnx0"};